import { useMusic } from '../hooks/useMusic.js'

export default function MusicToggle() {
  const { muted, toggleMute } = useMusic('/sounds/Carpe_Diem.mp3')

  return (
    <button
      type="button"
      onClick={toggleMute}
      title={muted ? 'Spela musik' : 'Stäng av musik'}
      aria-label={muted ? 'Spela musik' : 'Stäng av musik'}
      className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur-sm transition hover:bg-white/20 active:scale-95"
    >
      {muted ? '🔇' : '🎵'}
    </button>
  )
}
